const updateCountInTitle = (title: string, count: number) => {
  const countRegex = /\(.{1,4}\)/;

  if (countRegex.test(title)) {
    return title.replace(countRegex, `(${count})`);
  }

  title = `(${count}) ${title}`;
  return title;
};

const LOGOUT_PAGES = ['/c/', '/k/', '/j/', '/r/', '/search/'];

const isLogoutPage = (path: string) => {
  for (let pageIdentifier of LOGOUT_PAGES) {
    if (path.includes(pageIdentifier)) {
      return true;
    }
  }
  return false;
};

export {updateCountInTitle, isLogoutPage};
